import React from 'react';
import styled from 'styled-components';

import AbstractToggle from './AbstractToggle';
import Toggle from './Toggle';

const RadioToggle = styled(Toggle)`
  ${({ checked, theme }) =>
    checked
      ? `
    background: ${theme.modalToggleBgColor};
    border: 2px solid ${theme.modalToggleBorderColor};
    height: 16px;
    width: 16px;
    &::after {
      display: block;
      border-radius: 50%;
      margin: 2px 0 0 2px;
      height: 12px;
      width: 12px;
      background: ${theme.modalToggleCheckedBgColor};
      content: "";
    }
  `
      : ''}
`;

export default class Radio extends AbstractToggle {
  onChange = () => this.props.onChange(true);

  render() {
    return (
      <RadioToggle checked={!!this.props.checked} onClick={this.onChange} />
    );
  }
}
